import React, { useState, forwardRef, useImperativeHandle } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

export interface StripeCardHandle {
  handlePayment: () => Promise<boolean>;
}

const StripeCard = forwardRef<StripeCardHandle, { onCardSaved: (paymentMethodId: string) => void }>(
  ({ onCardSaved }, ref) => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState<string | null>(null);

    const handlePayment = async () => {
      if (!stripe || !elements) {
        setError("Stripe is not initialized");
        return false;
      }

      const { error: submitError } = await elements.submit();
      if (submitError) {
        setError(submitError.message || "An error occurred");
        return false;
      }

      const result = await stripe.createPaymentMethod({
        elements,
      });

      if (result.error) {
        // setError(result.error.message || "Payment failed");
        return false;
      }

      if (result.paymentMethod) {
        onCardSaved(result.paymentMethod.id);
        return true;
      }
      return false;
    };

    useImperativeHandle(ref, () => ({
      handlePayment
    }));

    return (
      <div className="stripe-card-form">
        <PaymentElement />
        {/* <div className="save-card-checkbox mt-3">
          <label className="d-flex align-items-center">
            <input
              type="checkbox"
              className="me-2"
              onChange={(e) => {
                if (bookingInfo?.payment_method !== 'pay_now') {
                  e.target.checked = false;
                } else if (!e.target.checked) {
                  setError("Please confirm to save the card");
                } else {
                  setError(null);
                }
              }}
            />
            I confirm to save this card for future payments
          </label>
        </div> */}
        {error && <p className="error-message">{error}</p>}
      </div>
    );
  }
);

StripeCard.displayName = 'StripeCard';

export default StripeCard;
